<template>
    <div>
        <dx-grid
            :url="url"
            :columns="columns"
            :title="title"
            :actions="actions"
            :onRowClicked="onRowClicked"
            navigationPath="onRowClicked"
            navigationField="onRowClicked"
            ref="grid"
        ></dx-grid>
        <v-dialog persistent v-model="updateDialog" max-width="1200">
            <v-card class="py-3 pl-3">
                <v-layout row justify-space-between class="pa-0 ma-0">
                    <v-card-title class="headline pl-0 pt-0"
                        >Case #{{ rowClicked.id }}</v-card-title
                    >
                    <v-spacer></v-spacer>
                    <audio
                        :src="rowClicked.recording"
                        controls=""
                        style="height: 25px"
                        class="mt-3 mr-3 mb-3"
                    ></audio
                ></v-layout>

                <v-layout row>
                    <v-flex xs4>
                        <h4 class="card-title font-weight-medium mt-2 mb-2">
                            {{ account.name }}
                        </h4>
                        <p class="mb-0">
                            {{ account.hname }}
                        </p>
                        <div class="mt-2 pt-2">
                            <v-layout row class="mb-2">
                                <div class="font-weight-medium mr-2">
                                    Account ID:
                                </div>
                                <div>
                                    {{
                                        account.accountID
                                            ? account.accountID
                                            : rowClicked.accountID
                                    }}
                                </div>

                                <a
                                    @click="openUnknownAccountDialog()"
                                    class="spacail-needs-link pl-2"
                                    >{{
                                        rowClicked.accountID == "Unassigned"
                                            ? "Assign"
                                            : "Change Account"
                                    }}</a
                                >
                            </v-layout>
                            <v-layout row class="mb-2" v-if="account.address1">
                                <div class="font-weight-medium mr-2">
                                    Address:
                                </div>
                                <div>
                                    {{ account.address1 }}
                                </div>
                            </v-layout>
                            <v-layout
                                row
                                class="mb-2"
                                v-if="account.emailAddress"
                            >
                                <div class="font-weight-medium mr-2">
                                    Email:
                                </div>
                                <div>
                                    {{ account.emailAddress }}
                                </div>
                            </v-layout>
                            <v-layout row class="mb-2">
                                <div class="font-weight-medium mr-2">
                                    Phone:
                                </div>
                                <div>
                                    {{
                                        rowClicked.phoneNumber
                                            ? rowClicked.phoneNumber
                                            : rowClicked.callerID | phone
                                    }}
                                </div>
                            </v-layout>
                            <v-layout
                                row
                                class="mb-2"
                                v-if="account.tuitionBalance"
                            >
                                <div class="font-weight-medium mr-2">
                                    Tuition Balance:
                                </div>
                                <div>
                                    {{ account.tuitionBalance | currency }}
                                </div>
                            </v-layout>
                        </div>
                    </v-flex>
                    <v-flex xs4>
                        <div class="mr-3">
                            <v-layout row class="mt-0 mb-2">
                                <v-select
                                    outline
                                    style="width: 50%"
                                    class="mr-2"
                                    label="Select Category"
                                    hide-details
                                    :items="categories"
                                    v-model="rowClicked.category"
                                    clearable
                                ></v-select>
                                <v-select
                                    outline
                                    style="width: 50%"
                                    class="mb-0"
                                    label="Select Status"
                                    :items="getStatusList()"
                                    clearable
                                    hide-details
                                    v-model="rowClicked.status"
                                ></v-select>
                            </v-layout>
                            <v-layout row class="mb-2">
                                <v-text-field
                                    outline
                                    hide-details
                                    label="Subject"
                                    v-model="rowClicked.subject"
                                ></v-text-field>
                            </v-layout>
                            <v-textarea
                                class="mb-0"
                                hide-details
                                label="Note"
                                v-model="rowClicked.note"
                                ref="note"
                                rows="4"
                                outline
                                font-weight-medium
                            ></v-textarea>
                        </div>
                    </v-flex>
                    <v-flex xs4>
                        <div class="mr-3">
                            <v-select
                                outline
                                class="mb-2"
                                label="AssignedTo"
                                hide-details
                                :items="users"
                                v-model="rowClicked.assignedTo"
                                clearable
                            ></v-select>
                            <v-select
                                outline
                                class="mb-2"
                                label="Building"
                                :items="buildings"
                                clearable
                                hide-details
                                v-model="rowClicked.building"
                            ></v-select>
                            <v-textarea
                                class="mb-0"
                                hide-details
                                label="Action"
                                v-model="rowClicked.action"
                                ref="action"
                                rows="2"
                                outline
                            ></v-textarea>
                            <v-layout row class="pa-0">
                                <div class="mr-3 pt-2">Satisfaction:</div>
                                <v-slider
                                    class="mt-0 pt-1"
                                    v-model="rowClicked.satisfactionLevelValue"
                                    :tick-labels="satisfactionLevels"
                                    :max="10"
                                    step="1"
                                ></v-slider>
                            </v-layout>
                        </div>
                    </v-flex>
                </v-layout>

                <v-layout row>
                    <div class="font-weight-regular pt-2 mt-3">
                        Email Conversation
                    </div>
                    <v-spacer></v-spacer>

                    <v-btn
                        color="success"
                        class="mt-2 mr-2"
                        v-if="rowClicked.status != 'COMPLETED'"
                        small
                        @click="openMarkCompletedDialog"
                    >
                        Complete
                    </v-btn>
                    <v-btn
                        :loading="processing"
                        color="success"
                        class="mt-2 mr-3"
                        small
                        @click="saveFeedback()"
                    >
                        Save
                    </v-btn>
                </v-layout>
                <div style="width: 100%; border-bottom: 2px solid;"></div>

                <v-layout column>
                    <div
                        class="email-messages-scroll-down"
                        v-bind:class="{
                            'height-150': showReply,
                            'height-350': !showReply,
                        }"
                    >
                        <v-layout
                            row
                            class="pa-0 ma-0"
                            v-for="(email, index) in feedbackEmails"
                        >
                            <v-spacer
                                v-if="getEmailAddress(email.from) != user"
                            ></v-spacer>
                            <v-card
                                class="pb-2 pt-0 mx-3 my-2"
                                style="width: 70%;"
                            >
                                <v-layout
                                    row
                                    justify-space-between
                                    class="pa-2"
                                    v-bind:class="getHeaderColor(email)"
                                    style="color: #fff; font-size: 12px;"
                                >
                                    <div class="pr-2">
                                        {{ email.date | time }}
                                    </div>
                                    <div class="pr-2">
                                        <span class="font-weight-medium"
                                            >From:</span
                                        >
                                        {{ getEmailAddress(email.from) }}
                                    </div>
                                    <div>
                                        <span class="font-weight-medium"
                                            >To:</span
                                        >
                                        {{ getEmailAddress(email.to) }}
                                    </div>
                                    <div v-if="email.cc">
                                        <span class="font-weight-medium"
                                            >CC:</span
                                        >
                                        {{ getEmailAddress(email.cc) }}
                                    </div>
                                </v-layout>
                                <!-- <div
                                    style="
                                        max-width: 1000px;
                                        white-space: pre-line !important;
                                        margin-top: -10px;
                                        border-bottom: 1px solid;
                                    "
                                    class="p-2 pl-2"
                                    v-if="email.data.Message"
                                >
                                    {{ email.data.Message }}
                                </div> -->
                                <div
                                    style="max-width: 1000px; white-space: pre-line !important; margin-top: -10px;"
                                    class="p-2 pl-2"
                                >
                                    {{ email.text }}
                                </div>
                            </v-card>
                        </v-layout>
                    </div>
                    <div
                        class="my-2 mr-2 px-2 pt-2"
                        style="border: solid 2px #4caf50; background-color: #fff;"
                        v-if="showReply"
                    >
                        <v-layout row class="my-2">
                            <v-combobox
                                style="width: 35%"
                                class="mr-2"
                                outline
                                label="From"
                                disabled
                                :rules="[rules.email]"
                                v-model="emailData.from"
                                ref="emailFrom"
                                :items="getEmailList()"
                                hide-details
                            ></v-combobox>
                            <v-combobox
                                style="width: 35%"
                                :items="getEmailList()"
                                class="mr-2"
                                outline
                                label="To"
                                :rules="[rules.email]"
                                v-model="emailData.to"
                                hide-details
                                ref="emailTo"
                            ></v-combobox>
                            <v-combobox
                                style="width: 35%"
                                :items="getEmailList()"
                                class=""
                                label="CC"
                                ref="emailCC"
                                outline
                                :rules="[rules.email]"
                                hide-details
                                v-model="emailData.cc"
                            ></v-combobox>
                        </v-layout>
                        <v-textarea
                            class="mb-2"
                            hide-details
                            label="Message"
                            v-model="emailData.message"
                            ref="emailMessage"
                            rows="1"
                            outline
                        ></v-textarea>
                        <v-card-actions class="ma-0 mb-3 py-0">
                            <v-btn
                                :loading="sending"
                                class="text-xs-center mt-0"
                                color="success"
                                block
                                small
                                @click="sendEmail"
                            >
                                Send Email
                            </v-btn>
                        </v-card-actions>
                    </div>
                </v-layout>

                <v-card-actions class="ml-0 pb-0">
                    <v-btn
                        small
                        color="success"
                        class="mr-1"
                        outline
                        @click="setShowReply()"
                        >{{ showReply ? "Cancel Reply" : "Reply" }}</v-btn
                    >
                    <v-btn
                        class=""
                        color="success"
                        small
                        outline
                        @click="openForwardDialog"
                        >Forward Ticket</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeDialog()"
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog persistent v-model="markCompletedDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Mark As Completed</v-card-title
                >

                <v-textarea
                    class="mb-0"
                    hide-details
                    label="Action"
                    v-model="rowClicked.action"
                    ref="action"
                    rows="4"
                    outline
                ></v-textarea>
                <v-layout row class="pa-0">
                    <div class="mr-3 pt-2">Satisfaction:</div>
                    <v-slider
                        class="mt-0 pt-1"
                        v-model="rowClicked.satisfactionLevelValue"
                        :tick-labels="satisfactionLevels"
                        :max="10"
                        step="1"
                    ></v-slider>
                </v-layout>

                <v-card-actions class="mr-1 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="markCompletedDialog = false"
                        >Close</v-btn
                    >
                    <v-btn
                        class=""
                        :loading="processing"
                        color="success"
                        @click="saveFeedback(true)"
                        >Confirm</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="unknownAccountDialog" max-width="500">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Assign Account</v-card-title
                >
                <div
                    class="pa-3"
                    style="border: 2px solid #4caf50; border-radius: 3px"
                >
                    <div class="subheading mb-2">
                        Select Account ID
                    </div>
                    <v-layout row class="pa-0">
                        <v-autocomplete
                            class=""
                            hide-details
                            label="Account ID"
                            placeholder="Start typing..."
                            hide-no-data
                            ref="newAccountID"
                            v-model="newAccountID"
                            :items="accounts"
                            :search-input.sync="loadAccounts"
                            @change="loadAccount"
                        ></v-autocomplete>
                        <v-btn
                            color="default"
                            dark
                            class="ml-3"
                            @click="searchAccountsDialog = true"
                            >Search Accounts</v-btn
                        >
                    </v-layout>
                    <v-checkbox
                        class="mt-2"
                        label="Save For Future"
                        color="success"
                        v-model="unknownAccount.saveForFuture"
                        hide-details
                    ></v-checkbox>
                </div>
                <div v-if="showSelectedUnknownAccount()" class="pt-3">
                    <div class="mb-2">{{ account.name }}</div>
                    <div class="mb-2">{{ account.nameH }}</div>
                    <div class="mb-2">
                        <span class="font-weight-medium mr-2">Account ID</span
                        >{{ account.accountID }}
                    </div>
                    <div class="mb-2">
                        <span class="font-weight-medium mr-2">Address</span
                        >{{ account.address1 }}
                    </div>
                    <div>
                        <span class="font-weight-medium mr-2">Home Phone</span
                        >{{ account.homePhone }}
                    </div>
                </div>
                <v-card-actions class="mr-0 mt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="closeUnknownDialog()"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveUnknownAccount(true)"
                    >
                        Save As Unassigned
                    </v-btn>
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="saveUnknownAccount()"
                    >
                        save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="searchAccountsDialog" max-width="1400">
            <v-card>
                <data-grid
                    class="accounts-search"
                    url="accounts"
                    :columns="accountsColumns"
                    title="Accounts"
                    navigationPath="onSearchAccountsRowClicked"
                    navigationField="onSearchAccountsRowClicked"
                    v-bind:hideActions="true"
                    :onRowClicked="onSearchAccountsRowClicked"
                ></data-grid>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="forwardDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0"
                    >Forward Ticket</v-card-title
                >
                <v-text-field
                    v-model="forwardData.from"
                    label="From"
                    :rules="[rules.email]"
                    ref="emailForwardFrom"
                    disabled
                ></v-text-field>
                <v-text-field
                    v-model="forwardData.to"
                    label="To"
                    :rules="[rules.email]"
                    ref="emailForwardTo"
                ></v-text-field>
                <v-text-field
                    v-model="forwardData.cc"
                    label="CC"
                    :rules="[rules.email]"
                    ref="emailForwardCC"
                ></v-text-field>
                <v-textarea
                    class="mb-0"
                    style="white-space: pre-line !important;"
                    v-model="forwardData.message"
                    label="Message"
                    rows="10"
                    outline
                ></v-textarea>
                <v-card-actions class="mr-0 mt-0 pt-0">
                    <v-spacer></v-spacer>
                    <v-btn color="default" dark @click="forwardDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        color="success"
                        :loading="sending"
                        @click="forwardTicket()"
                    >
                        Forward
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div></template
>
<script>
import moment from "moment";
import * as firebase from "firebase/app";
import "firebase/database";
import { onlyUnique } from "../../utils/helpers.js";
import { loadOptions } from "../../utils/smLookup.js";

export default {
    data: () => ({
        title: "הקול",
        columns: [
            {
                field: "statusIcon",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                },
                icon: (value) => {
                    switch (value) {
                        case "COMPLETED":
                            return "mdi-check-circle";
                        case "OPEN":
                            return "mdi-clock";
                        case "AWAITING RESPONSE":
                            return "mdi-message-alert";
                        default:
                            return "";
                    }
                },
                iconColor: (value) => {
                    switch (value) {
                        case "COMPLETED":
                            return "success";
                        case "OPEN":
                            return "#fdb400";
                        case "AWAITING RESPONSE":
                            return "info";
                        default:
                            return "#aeb8bf";
                    }
                },
            },
            {
                label: "Case Number",
                field: "id",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Account ID",
                field: "accountID",
                link: "Account View",
                format: "",
                template: "link-cell-template",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "NameH",
                field: "nameH",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: true,
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(
                    moment()
                        .subtract(7, "day")
                        .add(1, "day"),
                ),
                selectedFilterOperation: ">=",
            },
            {
                label: "From",
                field: "callerID",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Callback Number",
                field: "phoneNumber",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Recording",
                template: "link-audio-cell-template",
                field: "recording",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Subject",
                field: "subject",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Category",
                field: "category",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Note",
                field: "note",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Email Sent",
                field: "emailSent",
                type: "boolean",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Assigned To",
                field: "assignedTo",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Action",
                field: "action",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Building",
                field: "building",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Satisfaction Level",
                field: "satisfactionLevel",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Updated By",
                field: "updatedBy",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Updated At",
                field: "updatedAt",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                visible: false,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],

        actions: [],
        user: "",
        processing: false,
        rowClicked: "",
        updateDialog: false,
        showEmailToCustomer: false,
        categories: [],
        statusList: [],
        emailList: [],
        feedbackEmails: [],
        satisfactionLevels: [
            "0",
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
        ],

        account: "",

        emailTo: "",
        emailCC: "",
        sending: false,
        sendingToCustomer: false,
        showReply: false,

        emailToCustomer: {
            from: "",
            to: "",
            message: "",
        },

        emailData: {
            from: "hakol@email.utaw.org",
            to: "",
            cc: "",
            message: "",
        },

        fromEmails: [],
        buildings: [],
        users: [],

        unknownAccount: "",
        newAccountID: "",
        unknownAccountDialog: false,
        accounts: [],
        loadAccounts: null,
        markCompletedDialog: false,

        url: "feedback?includeCompleted=",

        forwardDialog: false,
        forwardData: {
            from: "",
            to: "",
            cc: "",
            message: "",
        },

        searchAccountsDialog: false,

        rules: {
            email: (value) => {
                if (!value) return true;

                const emails = value.split(";");

                const valid = emails.every((emailValue) => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

                    return pattern.test(emailValue);
                });

                return valid || "Invalid e-mail.";
            },
        },

        accountsColumns: [
            {
                sortable: true,
                label: "Name",
                field: "name",
                hidden: false,
                width: "200px",
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Name..",
                },
            },
            {
                sortable: false,
                label: "Account ID",
                field: "accountID",
                width: "115px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Account ID..",
                },
            },
            {
                sortable: false,
                label: "Hebrew Name",
                width: "250px",
                field: "hname",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Hebrew Name..",
                },
            },
            {
                sortable: false,
                label: "Home Phone",
                field: "homePhone",
                width: "150px",
                hidden: false,
                searchValue: (value) => {
                    return value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
                },
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Home Phone..",
                },
            },
            {
                sortable: false,
                label: "Cellphone",
                field: "cellPhone",
                width: "150px",
                hidden: false,
                searchValue: (value) => {
                    return value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
                },
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Cellphone..",
                },
            },
            {
                sortable: false,
                label: "Address",
                field: "address1",
                width: "200px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Address..",
                },
            },
            {
                sortable: false,
                label: "Email",
                field: "emailAddress",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Father",
                field: "father",
                hidden: true,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Shver",
                field: "shver",
                hidden: true,
                filterOptions: {
                    enabled: true,
                },
            },
        ],
    }),
    watch: {
        async loadAccounts(value) {
            if (!value) return;

            const response = await this.$http.get(
                "api/accounts/getAccountIDs?value=" + value,
            );

            this.accounts = response;
        },
    },
    mounted() {},
    beforeDestroy() {},
    async created() {
        this.user = this.$store.state.authentication.user;

        this.loadCategories();
        this.loadStatusList();
        this.loadBuildings();
        this.loadUsers();

        const emails = localStorage.getItem("feedback-sent-to-emails");

        this.emailList = emails ? JSON.parse(emails) : [];

        this.firebaseSetup();

        this.columns.find(
            (c) => c.field == "accountID",
        ).showLink = this.showLink;

        if (this.$route.query.caseNumber) {
            const feedback = await this.$http.get(
                "api/feedback/getByID?id=" + this.$route.query.caseNumber,
            );

            this.onRowClicked(feedback);
        }

        this.actions.push({
            text: "Show Completed",
            type: "switch",
            action: this.onShowCompletedChanged,
        });
    },
    methods: {
        onShowCompletedChanged(value) {
            if (value) {
                this.url = "feedback?includeCompleted=true";
            } else {
                this.url = "feedback?includeCompleted=";
            }

            this.$refs.grid.reloadDataSource(this.url);
        },
        showLink(row) {
            if (row.accountID == "Unassigned") return false;

            const claims = Array.isArray(
                this.$store.state.authentication.claims,
            )
                ? this.$store.state.authentication.claims
                : this.$store.state.authentication.claims
                ? this.$store.state.authentication.claims.split(",")
                : [];

            return (
                claims.some((c) => c == "Account View") ||
                this.getIsAdmin(this.$store.getters["authentication/isAdmin"])
            );
        },
        getIsAdmin(isAdmin) {
            if (!isAdmin || isAdmin == "false") return false;

            return true;
        },
        async onRowClicked(row) {
            this.rowClicked = JSON.parse(JSON.stringify(row));

            await this.loadFeedbackEmails();

            this.rowClicked.date = moment(
                new Date(this.rowClicked.date),
            ).format("YYYY-MM-DD HH:mm:ss");
            this.rowClicked.lastScan = moment(
                new Date(this.rowClicked.lastScan),
            ).format("YYYY-MM-DD HH:mm:ss");

            this.emailData.message = "";
            this.rowClicked.satisfactionLevelValue = this.rowClicked
                .satisfactionLevel
                ? this.satisfactionLevels.indexOf(
                      this.rowClicked.satisfactionLevel,
                  )
                : 0;

            this.rowClicked.originalStatus = this.rowClicked.status;

            if (!this.rowClicked.accountID) {
                this.openUnknownAccountDialog();

                return;
            }

            await this.loadAccount(this.rowClicked.accountID);

            this.updateDialog = true;
        },
        openMarkCompletedDialog() {
            this.markCompletedDialog = true;
        },
        openUnknownAccountDialog() {
            this.unknownAccount = this.rowClicked;

            if (
                this.rowClicked.accountID &&
                this.rowClicked.accountID != "Unassigned"
            ) {
                this.newAccountID = this.rowClicked.accountID;
                this.loadAccount(this.rowClicked.accountID);
            } else {
                this.newAccountID = "";
            }

            this.unknownAccount.saveForFuture = true;

            this.unknownAccountDialog = true;
        },
        async loadAccount(accountID) {
            if (accountID == "Unassigned") {
                this.account = "";

                return;
            }

            const response = await this.$http.get(
                "api/accounts/getAccount?accountID=" + accountID,
            );

            this.account = response;
        },
        onSearchAccountsRowClicked(account) {
            this.searchAccountsDialog = false;

            this.account = account;

            this.newAccountID = account.accountID;
        },
        firebaseSetup() {
            const firebaseConfig = {
                apiKey: "AIzaSyCtYeCL8HkqlMKJh6g6jcDvoH60-woVbDE",
                authDomain: "utaw.firebaseapp.com",
                databaseURL: "https://utaw.firebaseio.com",
                projectId: "project-683582246459980907",
                storageBucket: "project-683582246459980907.appspot.com",
                messagingSenderId: "193425158146",
                appId: "1:193425158146:web:f1ae134a803fb75832371b",
            };

            if (!firebase.apps.length) {
                firebase.initializeApp(firebaseConfig);
            }

            var database = firebase.database();
            var ref = firebase.database().ref("ticket-emails");

            const query = ref.limitToLast(100);

            query.on(
                "value",
                (snapshot) => {
                    if (this.rowClicked) {
                        this.loadFeedbackEmails();
                    }
                },
                function(error) {
                    console.log("Error: " + error.code);
                },
            );
        },
        async openForwardDialog() {
            this.forwardData.from = "hakol@email.utaw.org";

            this.forwardData.message = await this.$http.get(
                "api/feedback/getEmailText?feedbackID=" + this.rowClicked.id,
            );

            this.forwardDialog = true;
        },
        closeUnknownDialog() {
            if (!this.updateDialog) {
                this.account = "";
            }

            this.accounts = [];
            this.newAccountID = "";
            this.unknownAccountDialog = false;
        },
        showSelectedUnknownAccount() {
            return this.account.accountID;
        },
        async saveUnknownAccount(unassigned = false) {
            this.processing = true;

            try {
                await this.$http.post("api/feedback/assignAccount?", {
                    accountID: unassigned ? "Unassigned" : this.newAccountID,
                    user: this.user,
                    feedbackID: this.unknownAccount.id,
                    saveForFuture: this.unknownAccount.saveForFuture,
                });

                this.processing = false;

                this.account = "";
            } catch (e) {
                this.processing = false;

                return;
            }

            this.accounts = [];
            this.newAccountID = "";
            this.account = "";
            this.unknownAccountDialog = false;

            this.$refs.grid.reloadGrid();

            if (this.updateDialog) {
                const feedback = await this.$http.get(
                    "api/feedback/getByID?id=" + this.unknownAccount.id,
                );

                this.onRowClicked(feedback);
            }
        },
        async forwardTicket() {
            if (
                !this.forwardData.from ||
                !this.$refs.emailForwardFrom.validate(true)
            ) {
                this.$notify({
                    group: "notification",
                    text: this.forwardData.from
                        ? "Invalid From Email"
                        : "Missing From Email",
                    type: "error",
                });
                return;
            }

            if (
                !this.forwardData.to ||
                !this.$refs.emailForwardTo.validate(true)
            ) {
                this.$notify({
                    group: "notification",
                    text: this.forwardData.to
                        ? "Invalid To Email"
                        : "Missing To Email",
                    type: "error",
                });
                return;
            }

            if (!this.$refs.emailForwardCC.validate(true)) {
                this.$notify({
                    group: "notification",
                    text: "Invalid CC Email",
                    type: "error",
                });
                return;
            }

            if (!this.forwardData.message) {
                this.$notify({
                    group: "notification",
                    text: "Missing Message",
                    type: "error",
                });
                return;
            }

            this.sending = true;

            try {
                await this.$http.post("api/feedback/sendEmail", {
                    isForwarding: true,
                    from: this.forwardData.from,
                    to: this.forwardData.to,
                    cc: this.forwardData.cc,
                    message: this.forwardData.message,
                    subject: this.feedbackEmails[this.feedbackEmails.length - 1]
                        .subject,
                    feedback: this.rowClicked,
                });

                this.$notify({
                    group: "notification",
                    text: "Ticket Forwarded",
                    type: "success",
                });

                this.sending = false;

                this.feedbackEmails.unshift({
                    date: new Date(),
                    feedbackID: this.rowClicked.id,
                    from: this.forwardData.from,
                    to: this.forwardData.to,
                    cc: this.forwardData.cc,
                    text: this.forwardData.message,
                    subject: this.feedbackEmails[this.feedbackEmails.length - 1]
                        .subject,
                });

                this.forwardDialog = false;
                this.forwardData.from = "";
                this.forwardData.to = "";
                this.forwardData.cc = "";
                this.forwardData.message = "";

                this.loadFeedbackEmails();
            } catch (e) {
                this.sending = false;
                return;
            }
        },
        closeDialog() {
            //this.emailData.from = "";
            this.emailData.to = "";
            this.emailData.cc = "";
            this.emailData.message = "";
            this.showReply = false;

            this.account = "";

            this.updateDialog = false;
        },
        async saveFeedback(markAsCompleted = false) {
            if (markAsCompleted && !this.rowClicked.action) {
                return this.$notify({
                    group: "notification",
                    text: "Action required to mark as completed",
                    type: "error",
                });
            }

            try {
                this.processing = true;

                await this.$http.post("api/feedback/updateFeedback?", {
                    id: this.rowClicked.id,
                    note: this.rowClicked.note,
                    status: markAsCompleted
                        ? "COMPLETED"
                        : this.rowClicked.status,
                    category: this.rowClicked.category,
                    subject: this.rowClicked.subject,
                    assignedTo: this.rowClicked.assignedTo,
                    action: this.rowClicked.action,
                    building: this.rowClicked.building,
                    satisfied: this.rowClicked.satisfied,
                    satisfactionLevel:
                        this.rowClicked.satisfactionLevelValue == 0
                            ? ""
                            : this.satisfactionLevels[
                                  this.rowClicked.satisfactionLevelValue
                              ],
                    user: this.user,
                });

                this.processing = false;

                if (markAsCompleted) {
                    this.markCompletedDialog = false;

                    this.$notify({
                        group: "notification",
                        text: "Case Updated",
                        type: "success",
                    });
                }
            } catch (e) {
                this.processing = false;

                return;
            }

            this.updateDialog = false;

            this.$refs.grid.reloadGrid();
        },
        async loadCategories() {
            this.categories = (await loadOptions("HakolCategory")).map(
                (c) => c.value,
            );
        },
        async loadStatusList() {
            const statusList = (await loadOptions("HakolStatus"))
                .map((c) => c.value)
                .filter((s) => !["ARCHIVED"].includes(s));

            this.statusList = statusList;
        },
        getStatusList() {
            if (this.rowClicked.originalStatus == "COMPLETED")
                return this.statusList;

            return this.statusList.filter((s) => s != "COMPLETED");
        },
        async loadUsers() {
            this.users = (await loadOptions("HakolUser")).map((c) => c.value);
        },
        async loadBuildings() {
            this.buildings = (await loadOptions("HakolBuilding")).map(
                (c) => c.value,
            );
        },
        async loadFeedbackEmails() {
            const feedbackEmails = await this.$http.get(
                "api/feedback/getFeedbackEmails?feedbackID=" +
                    this.rowClicked.id,
            );

            let fromEmails = feedbackEmails
                .map((email) => this.getEmailAddress(email.from))
                .filter(onlyUnique);

            const classes = [
                "red-header",
                "purpal-header",
                "blue-header",
                "brown-header",
            ];

            fromEmails = fromEmails
                .filter((f) => f != this.user)
                .map((from, index) => {
                    return {
                        email: from,
                        headerClass: classes[index]
                            ? classes[index]
                            : "brown-header",
                    };
                });

            fromEmails.push({
                email: this.user,
                headerClass: "me-header",
            });

            this.fromEmails = fromEmails;

            this.feedbackEmails = feedbackEmails.map((feedbackEmail) => {
                feedbackEmail.data = feedbackEmail.data
                    ? JSON.parse(feedbackEmail.data)
                    : {};

                return feedbackEmail;
            });
        },
        getHeaderColor(email) {
            const fromEmail = this.fromEmails.find(
                (f) => f.email == this.getEmailAddress(email.from),
            );

            return fromEmail ? fromEmail.headerClass : "brown-header";
        },
        getEmailList() {
            const list = [].concat
                .apply(
                    [],
                    this.feedbackEmails.map((email) => {
                        const toList = email.to
                            ? email.to.split(",").map(this.getEmailAddress)
                            : [];
                        const ccList = email.cc
                            ? email.cc.split(",").map(this.getEmailAddress)
                            : [];

                        const list = [this.getEmailAddress(email.from)];

                        ccList.forEach((e) => list.push(e));
                        toList.forEach((e) => list.push(e));

                        return list;
                    }),
                )
                .filter(Boolean)
                .filter((email) => !email.endsWith("email.utaw.org"));

            if (this.rowClicked.emailAddress) {
                list.push(this.rowClicked.emailAddress);
            }

            return list
                .filter(onlyUnique)
                .map((e) => e.trim())
                .filter((e) => e != "hakol@utaw.org");
        },
        getEmailAddress(email) {
            if (!email) return;
            if (!email.includes("<")) return email.toLowerCase();

            var found = [],
                rxp = /<([^>]+)>/g,
                curMatch;

            while ((curMatch = rxp.exec(email))) {
                found.push(curMatch[1]);
            }

            return found.join(",").toLowerCase();
        },
        setShowReply() {
            this.showReply = !this.showReply;

            let from = this.getEmailAddress(this.feedbackEmails[0].from);

            let cc = this.feedbackEmails[0].cc
                ? this.getEmailAddress(this.feedbackEmails[0].cc)
                : "";

            if (
                ![
                    this.user.toLowerCase(),
                    "server@email.utaw.org",
                    "hakol@email.utaw.org",
                ].includes(from.toLowerCase())
            ) {
                this.emailData.to = from;
            } else if (
                cc &&
                "server@email.utaw.org" != cc.toLowerCase() &&
                "hakol@email.utaw.org" != cc.toLowerCase()
            ) {
                this.emailData.to = cc
                    .split(",")
                    .find(
                        (e) =>
                            e != "server@email.utaw.org" &&
                            e != "hakol@email.utaw.org",
                    );
            }

            //this.emailData.from = this.user;
        },
        async sendEmail() {
            // if (!this.emailData.from || !this.$refs.emailFrom.validate(true)) {
            //     this.$notify({
            //         group: "notification",
            //         text: this.emailData.from
            //             ? "Invalid From Email"
            //             : "Missing From Email",
            //         type: "error",
            //     });
            //     return;
            // }

            if (!this.emailData.to || !this.$refs.emailTo.validate(true)) {
                this.$notify({
                    group: "notification",
                    text: this.emailData.to
                        ? "Invalid To Email"
                        : "Missing To Email",
                    type: "error",
                });
                return;
            }

            if (!this.$refs.emailCC.validate(true)) {
                this.$notify({
                    group: "notification",
                    text: "Invalid CC Email",
                    type: "error",
                });
                return;
            }

            if (!this.emailData.message) {
                this.$notify({
                    group: "notification",
                    text: "Missing Message",
                    type: "error",
                });
                return;
            }

            this.sending = true;

            try {
                await this.$http.post("api/feedback/sendEmail", {
                    from: this.emailData.from,
                    to: this.emailData.to,
                    cc: this.emailData.cc,
                    message: this.emailData.message,
                    subject: this.feedbackEmails[this.feedbackEmails.length - 1]
                        .subject,
                    feedback: this.rowClicked,
                });
                if (!this.emailList.includes(this.emailTo)) {
                    this.emailList.push(this.emailTo);
                }
                localStorage.setItem(
                    "feedback-sent-to-emails",
                    JSON.stringify(this.emailList),
                );

                this.$notify({
                    group: "notification",
                    text: "Email Sent",
                    type: "success",
                });

                this.sending = false;
                //this.loadFeedbackEmails();
                this.$refs.grid.reloadGrid();

                this.feedbackEmails.unshift({
                    date: new Date(),
                    feedbackID: this.rowClicked.id,
                    from: this.emailData.from,
                    to: this.emailData.to,
                    cc: this.emailData.cc,
                    text: this.emailData.message,
                    subject: this.feedbackEmails[this.feedbackEmails.length - 1]
                        .subject,
                });

                this.showReply = false;
                //this.emailData.from = "";
                this.emailData.to = "";
                this.emailData.cc = "";
                this.emailData.message = "";
            } catch (e) {
                this.sending = false;
                return;
            }
        },
        async sendEmailToCustomer() {
            if (
                !this.$refs.emailToCustomerFrom.validate(true) ||
                !this.$refs.emailToCustomerTo.validate(true)
            )
                return;

            if (!this.emailToCustomer.from) {
                this.$notify({
                    group: "notification",
                    text: "Missing From Email",
                    type: "error",
                });

                return;
            }

            if (!this.emailToCustomer.to) {
                this.$notify({
                    group: "notification",
                    text: "Missing To Email",
                    type: "error",
                });

                return;
            }

            this.sendingToCustomer = true;

            try {
                await this.$http.post("api/feedback/sendEmailToCustomer", {
                    from: this.emailToCustomer.from,
                    to: this.emailToCustomer.to,
                    message: this.emailToCustomer.message,
                    feedback: this.rowClicked,
                });

                if (!this.emailList.includes(this.emailToCustomer.from)) {
                    this.emailList.push(this.emailToCustomer.from);
                }

                localStorage.setItem(
                    "feedback-sent-to-emails",
                    JSON.stringify(this.emailList),
                );

                this.$notify({
                    group: "notification",
                    text: "Email Sent To Customer",
                    type: "success",
                });

                this.$refs.grid.reloadGrid();

                this.sendingToCustomer = false;
            } catch (e) {
                this.sendingToCustomer = false;

                return;
            }
        },
    },
};
</script>
<style>
.gray-fg {
    color: #999;
}
.email-messages-scroll-down {
    overflow-y: auto;
    display: flex;
    flex-direction: column-reverse;
    background-color: #f1ffdc !important;
}
.height-150 {
    height: 150px;
}
.height-350 {
    height: 350px;
}
.me-header {
    background-color: #4caf50;
}
.red-header {
    background-color: #e62842;
}
.purpal-header {
    background-color: #8a3299;
}
.blue-header {
    background-color: #226da9;
}
.brown-header {
    background-color: #6b4436f5;
}
</style>
